import type { TimeZone } from "@eroad/types";

const NA_TIMEZONES: TimeZone[] = [
  {
    cities: "Anchorage_Bethel_Fairbanks_Juneau_Kenai_Ketchikan_Kodiak_Palmer_Sitka_Wasilla".split("_"),
    timeZone: "America/Anchorage",
  },
  {
    cities:
      "Austin_Baton Rouge_Birmingham_Chicago_Dallas_Houston_Kansas City_Memphis_Milwaukee_Minneapolis_New Orleans_Oklahoma City_San Antonio_St. Louis_Tulsa".split(
        "_",
      ),
    timeZone: "America/Chicago",
  },
  {
    cities:
      "Atlanta_Baltimore_Boston_Charlotte_Cleveland_Detroit_Miami_New York_Philadelphia_Pittsburgh_Raleigh_Tampa_Washington D.C.".split(
        "_",
      ),
    timeZone: "America/New_York",
  },
  {
    cities: "Aiea_Ewa Beach_Hilo_Honolulu_Kailua_Kaneohe_Kapolei_Mililani_Pearl City_Waipahu".split("_"),
    timeZone: "Pacific/Honolulu",
  },
  {
    cities:
      "Albuquerque_Aurora_Boise_Boulder_Cheyenne_Colorado Springs_Denver_Fort Collins_Provo_Salt Lake City_West Valley City".split(
        "_",
      ),
    timeZone: "America/Denver",
  },
  {
    cities:
      "Anaheim_Bakersfield_Fresno_Long Beach_Los Angeles_Oakland_Portland_Sacramento_San Diego_San Francisco_San Jose_Seattle_Stockton".split(
        "_",
      ),
    timeZone: "America/Los_Angeles",
  },
];

export { NA_TIMEZONES };
